import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { OfficeBiLabel } from '@/features/configurations';

const { LABS } = API_ENDPOINTS;

export interface LabsData {
  offices: OfficeBiLabel[];
}

export const labsApi = {
  getAll: () => apiClient.get<LabsData>(LABS.LIST),
  update: (data: LabsData) => apiClient.put<void>(LABS.UPDATE, data)
};
